import gql from 'graphql-tag';
import { useCustomQuery } from '../../../logic/api/graphQL/useCustomQuery';
import { PagingInputGq } from '../models/PagingInputGq';
import { PagingResultGq } from '../models/PagingResultGq';
import { TeamProjectAccessGq, TeamProjectAccessGqProps } from '../models/TeamProjectAccessGq';

export function useGetProjectAccessTeamsGq(command: CommandGq) {
  const query = useCustomQuery<GQLData, GQLVariables>(gqTag, {
    variables: { command: command },
  });

  return {
    query,
    teams: query.data?.users?.getProjectAccessTeams?.teamProjectAccess ?? null,
    pagingResult: query.data?.users?.getProjectAccessTeams?.pagingResult,
  };
}

const gqTag = gql`
  query GetProjectAccessTeams($command: GetProjectAccessTeams!) {
    users {
      getProjectAccessTeams(command: $command) {
        teamProjectAccess {${TeamProjectAccessGqProps}}
        pagingResult { ${PagingResultGq} }
      }
    }
  }
`;

interface GQLData {
  readonly users: {
    readonly getProjectAccessTeams: {
      readonly teamProjectAccess: TeamProjectAccessGq[];
      readonly pagingResult: PagingResultGq;
    };
  };
}

export interface GQLVariables {
  command: CommandGq;
}

export interface CommandGq {
  pagingInput: PagingInputGq;
  searchTerm: string;
  projectId?: number;
  excludeTeamIds?: number[];
}
